import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Table,
} from "@themesberg/react-bootstrap";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { Routes } from "../../routes";
import { authFetch } from "../../auth";
import queryString from "query-string";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import { MatProccessModal,ReqCancelModal } from "../../components/Modal";
import { CompanyTable, MatHistoryTable } from "../../components/Tables";

export default (props) => {
  const location = useLocation();
  const query = queryString.parse(location.search);
  const [checkedItems_send, setCheckedItems_send] = useState(new Set());
  const [checkedItems_recevie, setCheckedItems_recevie] = useState(new Set());

  var [list_send, setList_send] = useState([]);
  var [list_receive, setList_receive] = useState([]);
  var [list_history, setList_history] = useState([]);

  const [control, setControl] = useState({
    disabled: false,
    msgId: "",
  });
  const { disabled, msgId } = control;

  const [show, setShow] = useState(false);

  const [load, setLoad] = useState(false);

  const checkedItemHandler_send = (id, isChecked) => {
    if (isChecked) {
      checkedItems_send.add(id);
      setCheckedItems_send(checkedItems_send);
    } else if (!isChecked && checkedItems_send.has(id)) {
      checkedItems_send.delete(id);
      setCheckedItems_send(checkedItems_send);
    }
  };

  const checkedItemHandler_recevie = (id, isChecked) => {
    if (isChecked) {
      checkedItems_recevie.add(id);
      setCheckedItems_recevie(checkedItems_recevie);
    } else if (!isChecked && checkedItems_recevie.has(id)) {
      checkedItems_recevie.delete(id);
      setCheckedItems_recevie(checkedItems_recevie);
    }
  };

  const [bChecked_send, setChecked_send] = useState(false);
  const [bChecked_recevie, setChecked_recevie] = useState(false);

  const checkHandler_send = ({ target }, id) => {
    setChecked_send(!bChecked_send);
    checkedItemHandler_send(id, target.checked);
  };

  const checkHandler_recevie = ({ target }, id) => {
    setChecked_recevie(!bChecked_recevie);
    checkedItemHandler_recevie(id, target.checked);
  };

  useEffect(() => {
    authFetch(process.env.REACT_APP_API_URL + "/api/matching", {
      method: "GET",
    })
      .then((resp) => resp.json())
      .then((resp) => {
        if (resp) {
          setList_send(resp.json_list_send);
          setList_receive(resp.json_list_receive);
          setList_history(resp.json_list_history);
        }
      });
  }, []);

  // 매칭 취소
  const onCancelMatchingReq = () => {
    var Request_list = [];

    if (checkedItems_send.size === 0) return;

    setControl({ disabled: true });
    setLoad(true);

    checkedItems_send.forEach((matId) => {
      //console.log(item);
      Request_list.push(matId);
    });

    authFetch(process.env.REACT_APP_API_URL + "/api/cancelMatching", {
      method: "delete",
      body: JSON.stringify({
        requestList: Request_list,
      }),
    }).then((resp) => {
      if (resp.status === 200) {
        setControl((prev) => ({ ...prev, disabled: false }));
      } else {
        console.log(resp);
      }
    });
  };

  // 매칭 승낙
  const onConsentMatchingReq = () => {
    var Request_list = [];

    if (checkedItems_recevie.size === 0) return;

    checkedItems_recevie.forEach((matId) => {
      //console.log(item);
      Request_list.push(matId);
    });

    setControl((prev) => ({ show: true, disabled: true }));

    authFetch(process.env.REACT_APP_API_URL + "/api/confirmMatching", {
      method: "post",
      body: JSON.stringify({
        requestList: Request_list,
      }),
    }).then((resp) => {
      if (resp.status === 200) {
        console.log("resp 200");
        setControl((prev) => ({ ...prev, disabled: false }));
        window.location.reload();
      } else {
        console.log(resp);
      }
    });
  };

  // 매칭 거절
  const onRefuseMatchReq = () => {
    var Request_list = [];

    if (checkedItems_recevie.size === 0) return;

    setControl((prev) => ({ show: true, disabled: true }));

    checkedItems_recevie.forEach((item) => {
      //console.log(item);
      Request_list.push(item);
    });

    authFetch(process.env.REACT_APP_API_URL + "/api/refuseMatching", {
      method: "post",
      body: JSON.stringify({
        requestList: Request_list,
      }),
    }).then((resp) => {
      if (resp.status === 200) {
        setControl((prev) => ({ ...prev, disabled: false }));
        window.location.reload();
      } else {
        console.log(resp);
      }
    });
  };

  const onMatchingInfo = () => {
    setControl({
      infoShow: true,
    });
  };

  return (
    <Container fluid>
      <div className="bg-white shadow-soft border rounded border-light p-4 p-lg-5 w-100">
        <div className="text-center text-md-center mb-4 mt-md-0">
          <h3 className="m-3">
            <FormattedMessage id="requestedMat" />
          </h3>
          <CompanyTable companyList={list_send} handler={checkHandler_send} />
        </div>
        <div className="text-right">
          <Button variant="primary" onClick={onCancelMatchingReq}>
            취소
          </Button>
        </div>
      </div>
      <div className="bg-white shadow-soft border rounded border-light p-4 p-lg-5 w-100">
        <div className="text-center text-md-center mb-4 mt-md-0">
          <h3 className="m-3">
            <FormattedMessage id="incomMat" />
          </h3>

          <CompanyTable
            companyList={list_receive}
            handler={checkHandler_recevie}
          />
        </div>
        <div className="text-right">
          <Button variant="primary" onClick={onConsentMatchingReq}>
            승낙
          </Button>{" "}
          <Button variant="primary" onClick={onRefuseMatchReq}>
            거절
          </Button>
        </div>
      </div>
      <div className="bg-white shadow-soft border rounded border-light p-4 p-lg-5 w-100">
        <div className="text-center text-md-center mb-4 mt-md-0">
          <h3 className="m-3">
            <FormattedMessage id="matchingHistory" />
          </h3>
          {<MatHistoryTable historyList={list_history} />}
        </div>
      </div>
      {show && <MatProccessModal disabled={disabled} onCancel={() => {
            setShow((prev) => !prev);
          }}/>}
      {load && <ReqCancelModal disabled={disabled} />}
    </Container>
  );
};
